import { Navigate, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { useHasTool } from "../access/AccessProvider";
import { getLazyToolComponent } from "../tools/registry";

function DashboardsToolRoute() {
  const hasDashboards = useHasTool("dashboards");
  if (!hasDashboards) {
    return <Navigate to="/settings" replace />;
  }

  const DashboardsToolLayout = getLazyToolComponent("dashboards");
  if (!DashboardsToolLayout) {
    return <Navigate to="/settings" replace />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
          Loading Dashboards…
        </div>
      }
    >
      <DashboardsToolLayout />
    </Suspense>
  );
}

export const Route = createFileRoute("/_app/dashboards")({
  component: DashboardsToolRoute,
});
